<div id="contenedor" class="z-contenedor" style="scroll-behavior: smooth">
  <router-outlet></router-outlet>
  <input type="hidden" id="convenio" />
</div>

<app-loading [showLoading]="showLoader"></app-loading>
